import { Container } from '@sainsburys-tech/luna-grid'
import { Button } from '@sainsburys-tech/luna-button'
import { useNavigate } from 'react-router'
import { clearSessionData } from '../../utils/clearSessionData'

const ReportGuardingDailyActivity = () => {
  const navigateTo = useNavigate()
  
  const handleClick = () => {
    clearSessionData()
    sessionStorage.setItem('guardingChecklist', 'true')
    navigateTo("/reporting")
  }

  return (
    <Container className="ln-u-padding-ends*3" size="xs">
      <Button
        id="s-report-safety-accident"
        className="ln-u-bg-color-white report-accident-button report-accident-button-mobile"
        variant="outlined"
        disabled={false}
        element="button"
        onClick={handleClick}
        >
        Report a guarding activity
      </Button>
    </Container>
  );
};

export default ReportGuardingDailyActivity;